import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {FeaturePickerItem} from '../types/FeaturePickerItem';

type HandleCheckBoxSelectType = {
  value: string;
  selected: Nullish | string[];
  onFeatureSelect: (selected: string[]) => void;
  features: FeaturePickerItem[];
};
/**
 * Function to check or uncheck Checkbox in tree
 * When the last node is unchecked, all parents are unchecked too
 * @param value key of checked/unchecked node
 * @param selected array of keys - checked nodes
 * @param onFeatureSelect function witch should change the store, it gets new array of selected keys
 * @param features list of all features from catalogue
 */
export const handleCheckboxTreeSelect = (props: HandleCheckBoxSelectType) => {
  const selected = props.selected ?? [];

  // value is already selected - deselect it
  if (selected.includes(props.value)) {
    props.onFeatureSelect(selected.filter((item) => item !== props.value));
    return;
  }

  // first deselect all the relatives of the newly selected feature
  const topMostItem = findTopMostItem(props.value, props.features);
  const treeKeys = isNotNil(topMostItem) ? getAllTreeKeys(topMostItem) : [];
  const newSelection = selected.filter((item) => !treeKeys.includes(item));

  // then add the feature to the selection
  props.onFeatureSelect(newSelection.concat([props.value]));
};

const findTopMostItem = (
  key: string,
  features?: FeaturePickerItem[]
): FeaturePickerItem | undefined => {
  const findRecursive = (nodes: readonly FeaturePickerItem[]): boolean =>
    nodes.some((item) => item.value === key || (item.children && findRecursive(item.children)));

  return features?.find(
    (feat) => feat.value === key || (feat.children && findRecursive(feat.children))
  );
};

const getAllTreeKeys = (feature: FeaturePickerItem): string[] => {
  const keys: string[] = [];

  const traverseAndCollectKeys = (currentNode: FeaturePickerItem) => {
    if (!currentNode) {
      return;
    }
    if (isNotNil(currentNode.value)) {
      keys.push(currentNode.value);
    }
    currentNode.children?.forEach(traverseAndCollectKeys);
  };

  traverseAndCollectKeys(feature);
  return keys;
};
